import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import {
	ManagementLoansBulkUploadDto,
	PrepareOneSchemaManagementLoansCacheDto,
} from '@dealstack/shared/lib/generated';

export const prepareOneSchemaManagementLoansCache = async (
	args: PrepareOneSchemaManagementLoansCacheDto
) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: API_PATHS.ONE_SCHEMA_MANAGEMENT_LOANS_PREPARE_CACHE_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((r) => r.payload);
};

export const bulkUploadManagementLoans = async (args: ManagementLoansBulkUploadDto) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: API_PATHS.CAP_TRANSACTION_MANAGEMENT_LOANS_BULK_UPLOAD_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((r) => r.payload);
};
